/**
 * Crea los valores de todas las variables simples
 * @param {*} scene - Escena actual de Phaser
 */
export function crearVariables(scene) {

  scene.apuestaTotal = 0; // Apuesta total del jugador al iniciar la ruleta
  scene.premioTotal = 0;  // Premio total del jugador al iniciar la ruleta
  scene.valorUltimaApuesta = 0; // Valor de la última apuesta realizada
  scene.fichaSeleccionadaValor = 10; // Valor de la ficha seleccionada para apostar
  scene.noVaMas = false; // Indica si no se aceptan movimiento de fichas

  scene.imagenesNumerosApuesta = []; // Arreglo que guarda las imagenes(números) de la Apuesta Total
  scene.imagenesNumerosPremio = []; // Arreglo que guarda las imagenes(números) del Premio Total
  scene.imagenesNumerosAlfombra = []; // Arreglo que guarda las imagenes(números) de las fichas en la alfombra
  scene.imagenDisplayAlfombra = null; // Imagen que hace de display de los hover de las fichas en la alfombra

  //scene.imagenesNumerosGanancia = []; // Arreglo que guarda las imagenes(números) de la ganancia en la alfombra
  //scene.imagenDisplayGanancia = null; // Imagen que hace de display de los hover de las ganancias en la alfombra
}